<ng-template #template>
    <div class="sd-loading-indicator">
        <svg [iconName]="'icon-loading'" [size]="'auto'" sv-ng-svg-icon></svg>
    </div>
</ng-template>